// extracted by mini-css-extract-plugin
module.exports = {"form":"SendLetterForm_form__2Ct4p","submitButton":"SendLetterForm_submitButton__39qyK","centered":"SendLetterForm_centered__1fydW"};